import { render, staticRenderFns } from "./ViewProvider.vue?vue&type=template&id=66dea78a&"
import script from "./ViewProvider.vue?vue&type=script&lang=js&"
export * from "./ViewProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports